var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 28,
    xmlSpace: "preserve",
    id: "chatBubble",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chatBubble-group10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "chatBubble-fill1",
    fillRule: "evenodd",
    stroke: "none",
    fill: "rgb(245, 74, 120)",
    d: "M 18.19,12.99 C 18.19,13.8 18.81,14.42 19.68,14.42 20.55,14.42 21.17,13.8 21.17,12.99 21.17,12.22 20.55,11.54 19.68,11.54 18.81,11.54 18.19,12.22 18.19,12.99 Z M 18.19,12.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "chatBubble-fill3",
    fillRule: "evenodd",
    stroke: "none",
    fill: "rgb(245, 74, 120)",
    d: "M 12.51,12.99 C 12.51,13.8 13.13,14.42 14,14.42 14.87,14.42 15.49,13.8 15.49,12.99 15.49,12.22 14.87,11.54 14,11.54 13.13,11.54 12.51,12.22 12.51,12.99 Z M 12.51,12.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "chatBubble-fill5",
    fillRule: "evenodd",
    stroke: "none",
    fill: "rgb(245, 74, 120)",
    d: "M 6.83,12.99 C 6.83,13.8 7.45,14.42 8.32,14.42 9.19,14.42 9.81,13.8 9.81,12.99 9.81,12.22 9.19,11.54 8.32,11.54 7.45,11.54 6.83,12.22 6.83,12.99 Z M 6.83,12.99"
  }), /*#__PURE__*/React.createElement("g", {
    id: "chatBubble-group9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "chatBubble-clip8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "chatBubble-fill7",
    fillRule: "evenodd",
    stroke: "none",
    fill: "rgb(245, 74, 120)",
    d: "M 15.81,1.69 C 18.6,1.69 21.24,2.79 23.23,4.77 25.21,6.76 26.31,9.4 26.31,12.19 L 26.31,13.77 C 26.31,16.95 24.88,19.92 22.39,21.94 22.11,22.16 22,22.55 22.12,22.88 L 23.08,25.49 19.6,23.82 C 19.4,23.73 19.18,23.71 18.97,23.78 17.95,24.1 16.89,24.27 15.81,24.27 L 12.19,24.27 C 9.4,24.27 6.76,23.17 4.77,21.18 2.79,19.2 1.69,16.56 1.69,13.77 L 1.69,12.19 C 1.69,9.4 2.79,6.76 4.77,4.77 6.76,2.79 9.4,1.69 12.19,1.69 L 15.81,1.69 Z M 24.58,28 C 24.79,28 24.99,27.92 25.15,27.78 25.4,27.55 25.49,27.19 25.37,26.87 L 23.91,22.86 C 26.52,20.54 28,17.26 28,13.77 L 28,12.19 C 28,8.94 26.73,5.89 24.42,3.58 22.11,1.27 19.06,-0 15.81,-0 L 12.19,-0 C 8.94,-0 5.89,1.27 3.58,3.58 1.27,5.89 0,8.94 0,12.19 L 0,13.77 C 0,17.02 1.27,20.07 3.58,22.38 5.89,24.69 8.94,25.96 12.19,25.96 L 15.81,25.96 C 16.95,25.96 18.07,25.8 19.16,25.49 L 24.21,27.92 C 24.33,27.97 24.45,28 24.58,28 L 24.58,28 Z M 24.58,28"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuChat);
export default __webpack_public_path__ + "static/media/menu_chat.93f249dbfc0798010967e3a4a115f2a2.svg";
export { ForwardRef as ReactComponent };